import React from 'react'
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { Add as AddIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { PickupTimeSaveDto, WeeklyScheduleSaveDto } from '../../config/config'

interface WeeklyDayCardProps {
  day: WeeklyScheduleSaveDto
  dayName?: string
  isSaving: boolean
  expanded: boolean
  onToggleExpanded: (dayId: number) => void
  onActiveChange: (dayId: number, active: boolean) => void
  onAddPickupTime: (dayId: number) => void
  onPickupTimeChange: (
    dayId: number,
    index: number,
    field: keyof PickupTimeSaveDto,
    value: string
  ) => void
  onRemovePickupTime: (dayId: number, index: number) => void
  renderPickupTimesTable: (
    pickupTimes: PickupTimeSaveDto[],
    onChangeTime: (index: number, field: keyof PickupTimeSaveDto, value: string) => void,
    onRemove: (index: number) => void,
    emptyMessage: string
  ) => React.ReactNode
}

export const WeeklyDayCard: React.FC<WeeklyDayCardProps> = ({
  day,
  dayName,
  isSaving,
  expanded,
  onToggleExpanded,
  onActiveChange,
  onAddPickupTime,
  onPickupTimeChange,
  onRemovePickupTime,
  renderPickupTimesTable
}) => (
  <Box
    sx={{ mb: 2, borderRadius: 1, overflow: 'hidden', border: '1px solid', borderColor: 'divider' }}
  >
    <Box
      onClick={() => onToggleExpanded(day.dayId)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'grey.300',
        px: 2,
        py: 0.5,
        cursor: 'pointer'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {expanded ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
        <FormControlLabel
          sx={{ minWidth: 160, ml: 0.5 }}
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              checked={day.active}
              color='primary'
              onChange={(_e, checked) => onActiveChange(day.dayId, checked)}
            />
          }
          label={dayName}
        />
      </Box>
      <Button
        size='small'
        variant='contained'
        color='primary'
        disabled={isSaving}
        startIcon={<AddIcon fontSize='small' />}
        onClick={(e) => {
          e.stopPropagation()
          onAddPickupTime(day.dayId)
        }}
      >
        Agregar recolección
      </Button>
    </Box>
    {expanded && (
      <Box sx={{ pb: 2 }}>
        {renderPickupTimesTable(
          day.pickupTimes,
          (index, field, value) => onPickupTimeChange(day.dayId, index, field, value),
          (index) => onRemovePickupTime(day.dayId, index),
          'No hay horarios configurados. Haz clic en "Agregar recolección" para comenzar.'
        )}
        {day.active && day.pickupTimes.length === 0 && (
          <Typography variant='caption' color='error' sx={{ display: 'block', textAlign: 'center', mt: 1 }}>
            Este día está activo: debe agregar al menos un horario de recolección.
          </Typography>
        )}
      </Box>
    )}
  </Box>
)
